import styled from '@emotion/styled';
import { boxSizes, fontSizes, colors, fontWeights, gutterSizes, lineHeights } from '@gumtree/ui-library/src/base/theme';

export const QuoteDialogHeaderContainer = styled.div`
    display: flex;
    align-items: flex-start;
    gap: ${gutterSizes.base};
    padding: ${gutterSizes.large} ${gutterSizes.large40} ${gutterSizes.large} ${gutterSizes.base};
    border-bottom: 4px solid ${colors.bark10};
`;

export const ProfileImage = styled.div`
    width: ${boxSizes.boxHeight48};
    height: ${boxSizes.boxHeight48};
    border-radius: ${boxSizes.borderRadius4};
    object-fit: cover;
    flex-shrink: 0;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: ${boxSizes.borderRadius4};
    }

    svg {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: ${boxSizes.borderRadius4};
    }
`;

export const ContentSection = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: ${gutterSizes.base};
    min-width: 0;
`;

export const Title = styled.h3`
    margin: 0;
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.normal};
    line-height: ${lineHeights.base};
    color: ${colors.bark};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const PartnershipSection = styled.div`
    display: flex;
    align-items: center;
    gap: ${gutterSizes.base};
    background-color: ${colors.branch5};
    padding: 0 ${gutterSizes.base};
    border-radius: ${boxSizes.borderRadius4};
    width: fit-content;
`;

export const LogoImage = styled.img`
    width: 72.8px;
    height: 14px;
`;

export const BarkLogoImage = styled.img`
    width: 46.5px;
    height: 14px;
`;

export const PartnershipText = styled.span`
    font-size: ${fontSizes.small};
    font-weight: ${fontWeights.normal};
    line-height: ${lineHeights.small};
    color: ${colors.darkGrey};
    white-space: nowrap;
`;
